import { Progress } from '@sketchnote/shared-components';
import * as React from 'react';

const { useState, useRef, useEffect } = React;

export const MicrotaskProgress = ({ current, total }: { current: number; total: number }) => {
  const [completedWidth, setCompletedWidth] = useState(0);
  const barRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const completedProgressWidth = ((barRef.current?.clientWidth || 0) / total) * current;
    setCompletedWidth(completedProgressWidth);
  }, [current, total]);

  return (
    <div className="bg-gray-199 border-gray-200 bottom-0 mb-70 mt-40 px-36 py-8 rounded-full w-full z-50">
      <div className="flex items-center">
        <div className="mr-24 text-gray-500 font-medium" style={{ minWidth: '21rem' }}>
          {current}/{total} Tasks Complete
        </div>
        <Progress.Wrapper>
          <Progress.Bar
            barProps={{ ref: barRef }}
            progressedProps={{
              style: { width: completedWidth, transition: 'width 0.5s linear' },
            }}
            value={0}
          />
        </Progress.Wrapper>
      </div>
    </div>
  );
};
